import { CustomAxiosRequestConfig, http } from '../helpers/axiosHelper';

export default class PoolService {
   async get(search: string) {
      return await http
         .get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/pool', { params: { search }, cancelable: false } as CustomAxiosRequestConfig)
         .then((response) => {
            return response.data;
         });
   }
}
